import { Fab, makeStyles } from '@material-ui/core';
import { logoutLoggedInEmployee } from 'actions/loggedInEmployee';
import { useDispatch, useSelector } from 'react-redux';
import { selectMSTeamsContext } from 'selectors/msTeamsSelector';

import { LogoutIcon } from 'constants/icons';
import { isMobileView } from 'constants/isMobileView';

// @ts-expect-error mui error
const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    background: theme.palette.background.default,
    zIndex: '100',
  },
}));

export const MobileLogoutButton = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const msTeamsContext = useSelector(selectMSTeamsContext);
  const isMsTeamsView = Boolean(msTeamsContext);

  const handleLogout = () => {
    dispatch(logoutLoggedInEmployee());
  };

  // Show logout button only in mobile view and not in MS Teams view
  if (isMobileView() && !isMsTeamsView) {
    return (
      <Fab className={classes.fab} size="medium" onClick={handleLogout}>
        <LogoutIcon />
      </Fab>
    );
  }

  return null;
};
